import {
    seesAllProdi, isSuperAdmin, canManagePeerAssessment, isAdminInstalasi, bolehLihatKeaktifan, bolehKelolaSurvei,
    HALAMAN_PER_INSTALASI, HALAMAN_KEAMANAN_AKUN,
} from "./roles";

// SATU sumber kebenaran menu sidebar: kelompok -> menu -> {to, label, icon, testId, boleh(role)}. Sidebar (AppLayout.jsx)
// merender dari `daftarKelompok(role)`; fungsi murni, diuji menu.test.js. `icon` = kunci ikon (komponennya dipetakan di
// AppLayout). Hak akses per menu = `boleh` (daftar putih, persis sama dgn sebelum PR #110); backend tetap penegak utama.
// Kelompok tanpa menu yg boleh dilihat peran itu TIDAK ditampilkan; kelompok tanpa judul (Dashboard) tampil tanpa judul.
// `to` & `label` boleh fungsi (role) -- Rotasi Klinik Admin Instalasi menuju halaman Per Instalasi.
const BUKAN_INSTALASI = (role) => !isAdminInstalasi(role);
const SEMUA_PRODI = (role) => BUKAN_INSTALASI(role) && seesAllProdi(role);
// Menu khusus Super Admin (dulu tersarang di dalam seesAllProdi; Super Admin selalu termasuk seesAllProdi).
const KHUSUS_SUPER = (role) => SEMUA_PRODI(role) && isSuperAdmin(role);

export const KELOMPOK_MENU = [
    {
        id: "utama", judul: null, menu: [
            { to: "/dashboard", label: "Dashboard", icon: "dashboard", testId: "nav-dashboard", boleh: BUKAN_INSTALASI },
        ],
    },
    {
        id: "peserta-rotasi", judul: "PESERTA & ROTASI", menu: [
            { to: "/peserta", label: "Peserta Didik", icon: "peserta", testId: "nav-peserta", end: true, boleh: BUKAN_INSTALASI },
            { to: "/peserta/riwayat-import", label: "Riwayat Import", icon: "riwayat", testId: "nav-riwayat-import", indent: true, boleh: BUKAN_INSTALASI },
            // Admin Instalasi: satu-satunya menu kerja mereka (Per Instalasi); peran lain ke Rotasi Klinik biasa.
            { to: (role) => (isAdminInstalasi(role) ? HALAMAN_PER_INSTALASI : "/rotasi-klinik"), label: "Rotasi Klinik", icon: "rotasi",
              testId: "nav-rotasi-klinik", boleh: () => true },
            { to: "/orientasi-rs", label: "Orientasi RS", icon: "orientasi", testId: "nav-orientasi-rs", boleh: BUKAN_INSTALASI },
        ],
    },
    {
        id: "penilaian-survei", judul: "PENILAIAN & SURVEI", menu: [
            // Gerbang TERPISAH dari seesAll/isSuper: kalau canManagePeerAssessment diperluas ke peran lain, menu tetap benar.
            { to: "/peer-assessment", label: "Peer Assessment", icon: "peer", testId: "nav-peer-assessment",
              boleh: (role) => BUKAN_INSTALASI(role) && canManagePeerAssessment(role) },
            { to: "/survei-kepuasan", label: "Survei Kepuasan", icon: "survei", testId: "nav-survei-kepuasan",
              boleh: (role) => BUKAN_INSTALASI(role) && bolehKelolaSurvei(role) },
        ],
    },
    {
        id: "keuangan", judul: "KEUANGAN", menu: [
            { to: "/laporan/unit-cost", label: "Laporan Unit Cost", icon: "unitCost", testId: "nav-unit-cost", boleh: SEMUA_PRODI },
        ],
    },
    {
        id: "pengaturan", judul: "PENGATURAN", menu: [
            { to: "/prodi", label: "Program Studi", icon: "prodi", testId: "nav-prodi", boleh: SEMUA_PRODI },
            // Label baru; URL /data-rotasi-klinik TIDAK berubah (dulu "Data Rotasi Klinik").
            { to: "/data-rotasi-klinik", label: "Master Rotasi Klinik", icon: "dataRotasi", testId: "nav-data-rotasi-klinik", boleh: KHUSUS_SUPER },
            { to: "/pengaturan/periode", label: "Pengaturan Periode", icon: "periode", testId: "nav-periode", boleh: KHUSUS_SUPER },
            { to: "/pengaturan/tarif", label: "Tarif Unit Cost", icon: "tarif", testId: "nav-tarif", boleh: KHUSUS_SUPER },
        ],
    },
    {
        id: "akun-keamanan", judul: "AKUN & KEAMANAN", menu: [
            // Akun Admin khusus Super Admin: satu-satunya aksi Admin UFP di halaman itu (kirim link reset) tetap bisa dilakukan
            // pemilik akun lewat "Lupa Kata Sandi".
            { to: "/users", label: "Akun Admin", icon: "users", testId: "nav-users", boleh: KHUSUS_SUPER },
            // Gerbang sendiri (daftar putih), bukan disarangkan di seesAll.
            { to: "/keaktifan", label: "Keaktifan Akun", icon: "keaktifan", testId: "nav-keaktifan",
              boleh: (role) => BUKAN_INSTALASI(role) && bolehLihatKeaktifan(role) },
            { to: "/audit", label: "Audit Log", icon: "audit", testId: "nav-audit", boleh: SEMUA_PRODI },
            // Label baru; URL tidak berubah (dulu "Keamanan Akun"). Admin Instalasi juga memakainya (ganti kata sandi).
            // KECUALI Admin Instalasi: halaman mereka = Kata Sandi (tanpa 2FA), jadi labelnya tetap "Keamanan Akun".
            { to: HALAMAN_KEAMANAN_AKUN, label: (role) => (isAdminInstalasi(role) ? "Keamanan Akun" : "Autentikator (2FA)"), icon: "keamanan",
              testId: "nav-keamanan-akun", boleh: (role) => isAdminInstalasi(role) || KHUSUS_SUPER(role) },
        ],
    },
];

// Kelompok yg tampil utk `role`: [{id, judul, menu: [{to, label, icon, testId, end?, indent?}]}] (kelompok kosong dibuang).
export function daftarKelompok(role) {
    return KELOMPOK_MENU
        .map((k) => ({
            id: k.id, judul: k.judul,
            menu: k.menu.filter((m) => m.boleh(role)).map(({ boleh, to, label, ...sisa }) => ({
                ...sisa, to: typeof to === "function" ? to(role) : to, label: typeof label === "function" ? label(role) : label,
            })),
        }))
        .filter((k) => k.menu.length > 0);
}

// Daftar datar menu (urutan tampil), dipakai tes & pemeriksaan hak akses.
export const daftarMenu = (role) => daftarKelompok(role).flatMap((k) => k.menu);
